import * as React from 'react';
import Slide from '@mui/material/Slide';
import { Grid, Divider, Typography, TableBody, TableCell, TableHead, Checkbox, TableSortLabel, TableRow, Table, TableContainer, TablePagination } from '@mui/material';
import { Button } from '@material-ui/core';
import { useEffect, useState, useReducer, useContext } from 'react';
import { i18n } from '../../../translate/i18n';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import toastError from '../../../errors/toastError';
import api from '../../../services/api';
import { AuthContext } from '../../../context/Auth/AuthContext';
import socket from '../../../hooks/useSocket';
import ImportWhatsappMessageStoreModal from './storeModal';
import FormatDate from '../../../helpers/FormatDate';
import ConfirmationModal from '../../ConfirmationModal';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@material-ui/icons/PlayCircleFilledWhiteOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import CircularProgressWithLabel from '../../General/CircularProgressWithLabel';
import * as XLSX from 'xlsx';

const Transition = React.forwardRef(function Transition(
    props,
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    button: {
        position: "absolute",
        top: "15px",
        right: "0",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        "& svg": {
            color: theme.palette.primary.contrastText,
            marginRight: '5px'
        },
    },
    actionButton: {
        background: "#eeeeee",
        width: "35px",
        minWidth: "35px",
        marginLeft: "5px",
        "&:hover": {
            background: "#bdbdbd"
        }
    }
}));

const reducer = (state, action) => {
    if (action.type == "LOAD_REGISTERS") {
        const registers = action.payload;
        return !registers ? [] : registers;
    }

    if (action.type == "UPDATE_REGISTERS") {
        let { register } = action.payload;
        if (!register) register = action.payload;
        if (!register) return;

        if (!Array.isArray(state) || state.length == 0) return [register];
        const registerIndex = state.findIndex((r) => r.id == register.id);

        if (registerIndex != -1) {
            state[registerIndex] = register;
            return [...state];
        } else {
            return [register, ...state];
        }
    }

    if (action.type == "DELETE_REGISTER") {
        const registerId = action.payload;

        const registerIndex = state.findIndex((r) => r.id == registerId);
        if (registerIndex != -1) {
            state.splice(registerIndex, 1);
        }
        return [...state];
    }

    if (action.type === "RESET") {
        return [];
    }
};

const ValidateContactsModal = () => {

    const classes = useStyles();
    const fullWidth = true;
    const maxWidth = 'md';
    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [registers, dispatch] = useReducer(reducer, []);
    const [total, setTotal] = useState(0);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [page, setPage] = useState(0);
    const [storeModal, setStoreModal] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);
    const confirmationModalInitialState = {
        action: "",
        title: "",
        message: "",
        whatsAppId: "",
        open: false,
    };
    const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);

    useEffect(() => {

        const validateContactsEventName = `validateContacts-${user.adminId}`;
        const validateContactsEventFunction = async (data) => {
            if (data.action === "update" || data.action === "create") {
                dispatch({ type: "UPDATE_REGISTERS", payload: data.register });
            }
            if (data.action === "delete") {
                dispatch({ type: "DELETE_REGISTER", payload: +data.registerId });
            }
        };

        socket.on(validateContactsEventName, validateContactsEventFunction);

        return () => {
            socket.off(validateContactsEventName, validateContactsEventFunction);
        };
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get(`/contacts/importMessageHistory/list`, {
                    params: {
                        page: page + 1,
                        limit: rowsPerPage,
                        orderBy,
                        order,
                    },
                });

                dispatch({ type: "LOAD_REGISTERS", payload: data.registers }); // Verifique se o payload é o esperado
                setTotal(data.total);
            } catch (err) {
                console.error(err);
                toastError(err);
            } finally {
                setLoading(false);
            }
        })();

    }, [, page, rowsPerPage, order, orderBy]);

    const columns = [
        {
            id: "name",
            label: i18n.t("contacts.validateContacts.name"),
            sortable: true
        },
        {
            id: "createdAt",
            label: i18n.t("contacts.validateContacts.createdAt"),
            sortable: true
        },
        {
            id: "status",
            label: i18n.t("contacts.validateContacts.status.title"),
            sortable: true
        },
        {
            id: "connection",
            label: i18n.t("contacts.validateContacts.connection"),
            sortable: false
        },
        {
            id: "notValidatedsContacts",
            label: i18n.t("contacts.validateContacts.notValidatedsContacts"),
            sortable: false
        },
        {
            id: "validContacts",
            label: i18n.t("contacts.validateContacts.validContacts"),
            sortable: false
        },
        {
            id: "invalidContacts",
            label: i18n.t("contacts.validateContacts.invalidContacts"),
            sortable: false
        },
        {
            id: "totalContacts",
            label: i18n.t("contacts.validateContacts.totalContacts"),
            sortable: false
        },
        {
            id: "progress",
            label: i18n.t("contacts.validateContacts.progress"),
            sortable: false
        },
        {
            id: "actions",
            label: i18n.t("contacts.validateContacts.actions"),
            sortable: false,
            align: "left"
        },
    ];

    // função para ordenar a tabela, de acordo com a ordenação selecionada
    const sortTable = (array, comparator) => {
        return array.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
    }

    const getComparator = (order, orderBy) => {

        const descendingComparator = (a, b, orderBy) => {
            if (!a || !b) return 0;
            if (!(orderBy in a) || !(orderBy in b)) return 0;
            return (b[orderBy] < a[orderBy]) ? -1 : (b[orderBy] > a[orderBy]) ? 1 : 0;
        };

        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleClose = (event, reason) => {

        if (reason == 'backdropClick') {
            event.preventDefault();
            return;
        }

        setLoading(false);
        dispatch('RESET');
        setTotal(0);
        setOrder("asc");
        setOrderBy("createdAt");
        setRowsPerPage(20);
        setPage(0);
        setStoreModal(false);
        setSelectedEdit(null);
    }

    const handleModalClose = () => {
        setStoreModal(false);
        if (selectedEdit != null) setSelectedEdit(null);
    }

    const handleModalOpen = () => {
        setStoreModal(true);
    }

    const handleEditModal = (register) => {
        setStoreModal(true);
        setSelectedEdit(register);
    }

    const handleOpenConfirmationModal = (action, id) => {
        if (action == 'delete') {
            setConfirmModalInfo({
                action: "delete",
                title: i18n.t("contacts.validateContacts.deleteTitle"),
                message: i18n.t("contacts.validateContacts.deleteMessage"),
                id: id,
                open: true
            });
        }
    };

    const handleSubmitConfirmationModal = async () => {
        if (confirmModalInfo.action == 'delete') {
            try {
                await api.delete(`/contact/validateContacts/delete/${confirmModalInfo.id}`);
                toast.success(i18n.t("contacts.validateContacts.deletedSuccesfully"));
            } catch (err) {
                console.error({ err });
                return;
                toastError(err);
            }
        }
        if (confirmModalInfo.action == 'start') {
            await handleStart(confirmModalInfo.id);
            setTimeout(() => {
                handleClose();
            }, 500);
        }
        setConfirmModalInfo(confirmationModalInitialState);
    };

    const handleDownload = async (id) => {
        try {
            setLoading(true);
            const { data } = await api.get(`/contacts/importMessageHistory/show/${id}`);
            // montar array
            const completeData = [];
            if (Array.isArray(data?.contacts)) {
                for (const contact of data.contacts) {
                    let convertedJson = null;
                    try {
                        convertedJson = JSON.parse(contact.extraInfo)
                    } catch (err) {

                    }

                    const data = contact?.createdAt ? FormatDate(contact.createdAt) : "";
                    const numeroValidado = convertedJson?.numero || "";
                    const numeroOriginal = contact?.phoneNumber || "";
                    const validacao = contact?.status ? i18n.t(`contacts.validateContacts.status.${contact.status}`) : "";
                    const status = convertedJson?.status || "";
                    const picUrl = convertedJson?.picUrl ? { f: `HYPERLINK("${convertedJson.picUrl}", "Visualizar Imagem")` } : "";
                    const descricao = convertedJson?.descricao || "";
                    const email = convertedJson?.email || "";
                    const site = Array.isArray(convertedJson?.site) ? convertedJson.site.join(", ") : "";
                    const categoria = convertedJson?.categoria || "";
                    const endereco = convertedJson?.endereco || "";
                    const horarioDeAtendimento = convertedJson?.horarioDeAtendimento || "";
                    const zonaHrarioDeAtendimento = convertedJson?.zonaHorarioDeAtendimento || "";

                    completeData.push({
                        numeroOriginal,
                        data,
                        validacao,
                        numeroValidado,
                        status,
                        picUrl,
                        descricao,
                        email,
                        site,
                        categoria,
                        endereco,
                        horarioDeAtendimento,
                        zonaHrarioDeAtendimento
                    });
                }
            }
            if (Array.isArray(completeData) && completeData.length > 0) {
                // Cria uma nova planilha
                const worksheet = XLSX.utils.json_to_sheet(completeData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                // Converte o workbook para binário
                const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

                // Define o nome do arquivo
                const sanitizeFileName = (name) =>
                    name
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '') // remove acentos
                        .replace(/[\\/:*?"<>|]/g, '_')   // substitui caracteres inválidos
                        .trim()
                        .toLowerCase();
                const fileName = data?.name ? `${sanitizeFileName(data.name)}.xlsx` : "validacao_contatos.xlsx";

                // Função auxiliar para converter string em buffer
                const s2ab = (s) => {
                    const buf = new ArrayBuffer(s.length);
                    const view = new Uint8Array(buf);
                    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                };

                // Cria um blob a partir do buffer
                const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);

                // Remove o link e libera o objeto URL
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
            toast.success(i18n.t("Arquivo gerado com sucesso."));
        } catch (err) {
            console.error({ err });
            toastError(err);
            return;
        } finally {
            setLoading(false);
        }
    }

    const handleStart = async (id) => {
        try {
            await api.post(`/contact/validateContacts/start`, { id });
            toast.success(i18n.t("contacts.validateContacts.startedSuccesfully"));
        } catch (err) {
            console.error({ err });
            toastError(err);
        }
    };

    const handleChangePage = (event, newPage) => {
        // Verifica se a nova página está dentro dos limites
        if (newPage < 0) {
            setPage(0);
        } else if (newPage >= total) {
            setPage(total - 1);
        } else {
            setPage(newPage);
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} mb={2} style={{ position: "relative" }}>
                    <Typography variant="h5" style={{ fontWeight: "600" }}>{i18n.t("contacts.validateContacts.title")}</Typography>
                    <Button
                        size="small"
                        variant="contained"
                        className={classes.button}
                        onClick={handleModalOpen}
                        disabled={Array.isArray(registers) && registers.findIndex(r => r.status == 'starting') != -1}
                    >
                        {i18n.t("contacts.validateContacts.buttons.add")}
                    </Button>
                    <Divider sx={{ marginTop: "10px" }} />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columns.map((col, index) => {
                                        const isSortable = col.sortable != false;
                                        return (
                                            <TableCell
                                                key={`${index}-importWhatsappMessage`}
                                                align={col?.align ? col.align : "left"}
                                                sortDirection={isSortable && orderBy === col.id ? order : false}
                                            >
                                                {isSortable ? (
                                                    <TableSortLabel
                                                        active={orderBy === col.id}
                                                        direction={orderBy === col.id ? order : "asc"}
                                                        onClick={createSortHandler(col.id)}
                                                    >
                                                        {col.label}
                                                    </TableSortLabel>
                                                ) : (
                                                    col.label
                                                )}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    Array.isArray(registers) && registers.length > 0 ?
                                        sortTable(registers, getComparator(order, orderBy)).map(r => {
                                            return (
                                                <TableRow>
                                                    <TableCell>{r?.name || ""}</TableCell>
                                                    <TableCell>{FormatDate(r.createdAt)}</TableCell>
                                                    <TableCell>{i18n.t(`contacts.validateContacts.status.${r.status}`)}</TableCell>
                                                    <TableCell>{r?.Connection?.name || '-'}</TableCell>
                                                    <TableCell>{r?.notValidatedContacts || '0'}</TableCell>
                                                    <TableCell>{r?.validContacts || '0'}</TableCell>
                                                    <TableCell>{r?.invalidContacts || '0'}</TableCell>
                                                    <TableCell>{r?.totals || '0'}</TableCell>
                                                    <TableCell>
                                                        <CircularProgressWithLabel
                                                            value={r?.totals > 0 && r?.notValidateds > 0 ? ((r.notValidateds / r.totals) * 100).toFixed(0) : '0'}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            title={i18n.t("buttons.download")}
                                                            size="small"
                                                            className={classes.actionButton}
                                                            disabled={r?.status == "pending" ? true : false}
                                                            onClick={e => {
                                                                handleDownload(r.id);
                                                            }}
                                                        >
                                                            <GetAppOutlinedIcon />
                                                        </Button>
                                                        <Button
                                                            title={i18n.t("buttons.delete")}
                                                            size="small"
                                                            className={classes.actionButton}
                                                            onClick={e => {
                                                                handleOpenConfirmationModal('delete', r.id);
                                                            }}
                                                        >
                                                            <DeleteOutlineOutlinedIcon />
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        :
                                        <TableRow>
                                            <TableCell
                                                colSpan={columns.length + 1}
                                                align="center"
                                            >
                                                {i18n.t("contacts.validateContacts.notFound")}
                                            </TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TablePagination
                        rowsPerPageOptions={[20, 50, 100]}
                        component="div"
                        count={total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        labelRowsPerPage={i18n.t("contacts.validateContacts.resultPerPage")}
                        labelDisplayedRows={({ from, to, count }) => `${i18n.t("contacts.validateContacts.total")} ${count} / ${i18n.t("contacts.validateContacts.from")} ${from} ${i18n.t("contacts.validateContacts.to")} ${to}`}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                                marginTop: "10px"
                            },
                        }}
                    />
                </Grid>
            </Grid>
            <ImportWhatsappMessageStoreModal
                open={storeModal == true ? true : false}
                onClose={handleModalClose}
                id={selectedEdit?.id || undefined}
            />
            <ConfirmationModal
                title={confirmModalInfo.title}
                open={confirmModalInfo?.open == true ? true : false}
                onClose={() => {
                    setConfirmModalInfo(confirmationModalInitialState);
                }}
                onConfirm={handleSubmitConfirmationModal}
            >
                {confirmModalInfo.message}
            </ConfirmationModal>
        </>
    );
}

export default ValidateContactsModal;